import APIRequest from "./APIRequest";

// Admin Authentication Services
export const adminLogin = (params) => {
  return APIRequest.post(`auth/login`, params);
};

export const adminLogout = (params) => {
  return APIRequest.post(`auth/logout`, params);
};

export const adminRegister = (params) => {
  return APIRequest.post(`admin/auth/register`, params);
};

export const adminForgotPassword = (params) => {
  return APIRequest.post(`admin/auth/forgot-password`, params);
};

export const adminResetPassword = (params) => {
  return APIRequest.post(`admin/auth/reset-password`, params);
};

export const verifyAdminToken = (params) => {
  return APIRequest.get(`admin/auth/verify`, params);
};

export const refreshAdminToken = (params) => {
  return APIRequest.post(`admin/auth/refresh`, params);
};